import { BaseField } from "./base";

export class FormattedNumberField extends BaseField {
	constructor(field, form) {
		super(field, form);
		this.sourceField = this.field.dataset.sourceField;
		this.formatOptions = JSON.parse(this.field.dataset.formatOptions);
	}

	init() {
		if (!this.sourceField) {
			this.showError("You need to specify a source field");
			return;
		}

		if (this.formatOptions.hide) {
			this.field.closest(".form-group").style.display = "none";
		}

		this.form.addEventListener("input", () => {
			const sourceElement = this.form.querySelector(
				`[name="${this.sourceField}"]`,
			);
			if (sourceElement) {
				this.updateValue(sourceElement.value);
			}
		});

		// Get initial value
		const sourceElement = this.form.querySelector(
			`[name="${this.sourceField}"]`,
		);
		if (sourceElement) {
			this.updateValue(sourceElement.value);
		} else {
			this.showError(`Source field "${this.sourceField}" not found`);
		}
	}

	updateValue(value) {
		const number = parseFloat(value);
		if (isNaN(number)) {
			this.field.value = "";
			return;
		}

		try {
			const formatter = new Intl.NumberFormat(this.formatOptions.locale, {
				style: this.formatOptions.style,
				currency:
					this.formatOptions.style === "currency"
						? this.formatOptions.currency
						: undefined,
				minimumFractionDigits: this.formatOptions.decimals,
				maximumFractionDigits: this.formatOptions.decimals,
			});
			this.field.value = formatter.format(number);
		} catch (e) {
			this.showError(e.message);
		}
	}

	showError(msg) {
		this.field.value = `Formatted number field: ${msg}`;
		this.field.style.color = "red";
	}
}
